import React from "react";
import { useEffect } from "react";
const CancelPage = () => {
  const handleRetry = () => {
    window.location.href = "/admin"; // Redirects back to subscription section
  };

  const handleHome = () => {
    window.location.href = "/";
  };
    useEffect(() => {
        // Optional: Analytics or toast notification
    }, []);
  return (
    <div style={styles.container}>
      <h1 style={styles.heading}>❌ Subscription Canceled</h1>
      <p style={styles.message}>It looks like your payment wasn't completed.</p>

      <div style={styles.buttonGroup}>
        <button onClick={handleRetry} style={{ ...styles.button, backgroundColor: "#007bff" }}>
          🔁 Try Again
        </button>
        <button onClick={handleHome} style={{ ...styles.button, backgroundColor: "#6c757d" }}>
          🏠 Return Home
        </button>
      </div>
    </div>
  );
};

const styles = {
  container: {
    textAlign: "center",
    padding: "2rem",
    fontFamily: "Arial, sans-serif",
  },
  heading: {
    color: "#dc3545",
  },
  message: {
    marginTop: "1rem",
    marginBottom: "2rem",
  },
  buttonGroup: {
    display: "flex",
    justifyContent: "center",
    gap: "1rem",
    flexWrap: "wrap",
  },
  button: {
    color: "white",
    border: "none",
    padding: "10px 20px",
    borderRadius: "6px",
    fontSize: "16px",
    cursor: "pointer",
  },
};

export default CancelPage;
